// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SZNTfkEhsENNtG {
  display: grid;
  grid-template-columns: repeat(4, calc(25% - var(--ds-space-100, 8px)));
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-200, 16px);
  column-gap: var(--ds-space-100, 8px);
  row-gap: var(--ds-space-100, 8px);
}
.nGA5AvWmR14QZY {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-050, 4px);
  padding: var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
@media only screen and (max-width: 600px) {
  .SZNTfkEhsENNtG {
    grid-template-columns: repeat(3, calc(33.3% - var(--ds-space-100, 8px)));
  }
}
@media only screen and (max-width: 450px) {
  .SZNTfkEhsENNtG {
    grid-template-columns: repeat(auto-fill, minmax(120px, calc(50% - var(--ds-space-100, 8px))));
  }
}
`, ""]);
// Exports
export var boardTiles = `SZNTfkEhsENNtG`;
export var boardList = `nGA5AvWmR14QZY`;
export default ___CSS_LOADER_EXPORT___;
